import React from "react"
import DateCustomToolbar from "./DateCustomToolbar"

function CommonToolbar(props) {
  const { currentDate, setCurrentDate } = props

  const handleNavigate = (action) => {
    const newDate = new Date(currentDate)
    if (action === "PREV") {
      newDate.setDate(currentDate.getDate() - 1)
    } else if (action === "NEXT") {
      newDate.setDate(currentDate.getDate() + 1)
    }
    setCurrentDate(newDate)
  }

  const handleToday = () => {
    setCurrentDate(new Date())
  }

  return (
    <div>
      <DateCustomToolbar
        // {...toolbarProps}
        onNavigate={handleNavigate}
        onToday={handleToday}
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
      />
    </div>
  )
}

export default CommonToolbar
